// extracted by mini-css-extract-plugin
export default {"reviewDetails":"style--reviewDetails--b07751","treatmentRating":"style--treatmentRating--866716","buttonContainer":"style--buttonContainer--bc96af"};